const products = {
  permissionSource: 'api::product.product',
  creationTitle: 'Create Product',
  creationEndPoint: '/products',
  detailTitle: 'Product: :title',
  detailEndPoint: '/products/:id?populate=*',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Code',
          value: 'code',
          tag: 'input',
          type: 'text',
          placeholder: 'Product Code',
          required: true,
        },
        {
          label: 'Name',
          value: 'name',
          tag: 'input',
          type: 'text',
          placeholder: 'Product Name',
          required: true,
        },
        {
          label: 'Ledger',
          value: 'product_ledger',
          tag: 'single-select',
          dataSourceUrl: '/ledgers',
          dataLabel: 'title',
        },
      ],
    },
    {
      label: 'Description',
      value: 'description',
      tag: 'richTextarea',
      placeholder: 'Support any customized shortcodes',
      popUpText: 'Support any customized shortcodes',
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Is virtual product?',
          value: 'is_virtual_product',
          tag: 'switch',
        },
        {
          label: 'Barcode',
          value: 'barcode',
          tag: 'input',
          type: 'text',
          placeholder: 'Product Barcode',
        },
        {
          label: 'Preset Price',
          value: 'preset_price',
          tag: 'input',
          type: 'number',
          placeholder: 'Preset Price',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Product Unit',
          value: 'product_unit',
          tag: 'single-select',
          dataSourceUrl: '/product-units',
          dataLabel: 'label',
        },
        {
          label: 'Product Line',
          value: 'product_line',
          tag: 'single-select',
          dataSourceUrl: '/product-lines',
          dataLabel: 'title',
        },
        {
          label: 'Material Category',
          value: 'material_category',
          tag: 'single-select',
          dataSourceUrl: '/material-categories',
          dataLabel: 'title',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Expiry Date',
          value: 'expiration_date',
          tag: 'date-picker',
        },
        {
          label: 'Expired Alarm Target Emails',
          value: 'expired_alarm_target_emails',
          tag: 'input',
          type: 'text',
          validateGroup: ['multiple-emails'],
          placeholder: 'Support multiple email address',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
}
export default products
